import { isNotNull } from './is-not-null.js';

export function isNotNullObjectEntry<K extends string, V>(
  entry: [K, V]
): entry is [K, Exclude<V, null>] {
  return isNotNull(entry[1]);
}
